import type { ActionConfig } from './types';

export const scheduleActions: ActionConfig[] = [
  // =============================================================================
  // RECORD ACTIONS
  // =============================================================================
  {
    id: 'schedule-edit',
    name: 'Edit',
    icon: 'edit',
    table: 'schedules',
    type: 'EDIT_RECORD',
    prominence: 'prominent',
    order: 1,
    config: {},
  },
  {
    id: 'schedule-add',
    name: 'Add',
    icon: 'plus',
    table: 'schedules',
    type: 'ADD_RECORD',
    prominence: 'prominent',
    order: 2,
    config: {},
  },

  // =============================================================================
  // NAVIGATION ACTIONS
  // =============================================================================
  {
    id: 'schedule-view-client',
    name: 'View Client',
    icon: 'chevron-circle-right',
    table: 'schedules',
    type: 'NAVIGATE_APP',
    prominence: 'inline',
    order: 10,
    config: {
      route: '/clients/:clientId',
      params: { clientId: 'clientId' },
    },
  },
  {
    id: 'schedule-map-route',
    name: 'Map Route',
    icon: 'map-marker',
    table: 'schedules',
    type: 'NAVIGATE_APP',
    prominence: 'prominent',
    order: 11,
    config: {
      route: '/schedules/map',
      params: { route: 'route' },
    },
  },
  {
    id: 'schedule-view-ready-wos',
    name: 'View Ready WOs',
    icon: 'list-ol',
    table: 'schedules',
    type: 'NAVIGATE_APP',
    prominence: 'prominent',
    order: 12,
    condition: (row) => {
      // Show when there are ready work orders for this schedule
      const readyWOCount = Number(row.readyWOCount) || 0;
      return readyWOCount > 0;
    },
    config: {
      route: '/workorders',
      params: { scheduleId: 'key', status: '4. Ready for Pickup' },
    },
  },

  // =============================================================================
  // EXPORT ACTIONS
  // =============================================================================
  {
    id: 'schedule-download',
    name: 'Download',
    icon: 'download',
    table: 'schedules',
    type: 'EXPORT_VIEW',
    prominence: 'menu',
    order: 50,
    config: {},
  },
];
